class DeleteRole {
	constructor(
		public readonly accountId: number,
		public readonly roleId: number,
	) {
		Object.freeze(this);
	}
}

export default DeleteRole;
